import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-items-center justify-content-center h-100" }
const _hoisted_2 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock("h1", _hoisted_2, _toDisplayString(_ctx.$t("general.loggedOutText")), 1))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock("h1", _hoisted_3, _toDisplayString(_ctx.$t("general.loggingIn")), 1))
      : _createCommentVNode("", true),
    (!_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 2,
          label: _ctx.$t('general.goToLogin'),
          onClick: _ctx.onGoToLoginClick,
          class: "p-button-text"
        }, null, 8, ["label", "onClick"]))
      : _createCommentVNode("", true)
  ]))
}